import React from "react";
import "./AboutUs.css";

const AboutUs = () => {
  return (
    <div className="aboutus-container">
      {/* Banner Section */}
     {/* Our Story Section */}
<div className="our-story">
  <h2>Our Story</h2>
  <p>
    Our journey began with a simple yet powerful vision: to provide children with 
    more than just a place to live, to give them a true sense of belonging, safety, and hope for the future.
  </p>
  <p>
    Founded by a group of professionals with backgrounds in social care, 
    education, and child development, Careplus Homes was created to fill 
    a gap in providing high-quality residential care that balances structure with warmth.
  </p>
  <p>
  Over the years, we have grown into a trusted children’s care home where young 
  people receive not only shelter but also emotional support, guidance, and 
  opportunities to develop life skills. Our team works tirelessly to create a 
  family-like environment, empowering children to heal, grow, and look ahead with confidence.
  </p>
</div>



{/* Boosting Businesses (stats) */}
<div className="boosting-section">
  <h2 className="boosting-title">Our Values</h2>

  <div className="boosting-grid">
    {/* 1 */}
    <div className="boosting-item">
      <div className="bb-icon">
        {/* abstract leaf/capsule shape */}
        <svg viewBox="0 0 300 160" aria-hidden="true">
          <rect x="60" y="35" width="180" height="40" rx="30" />
          <rect x="60" y="85" width="180" height="40" rx="30" />
        </svg>
      </div>
      <div className="bb-number">Community</div>
      <div className="bb-label">Creating strong relationships with families, schools, and local services</div>
    </div>

    {/* 2 */}
    <div className="boosting-item">
      <div className="bb-icon">
        {/* small + large circle */}
        <svg viewBox="0 0 300 160" aria-hidden="true">
          <circle cx="90" cy="110" r="40" />
          <circle cx="185" cy="80" r="70" />
        </svg>
      </div>
      <div className="bb-number">Compassion</div>
      <div className="bb-label">Every child deserves kindness and understanding</div>
    </div>

    {/* 3 */}
    <div className="boosting-item">
      <div className="bb-icon">
        {/* rounded U/arch */}
        <svg viewBox="0 0 300 160" aria-hidden="true">
          <path d="M60 60a60 60 0 0 1 120 0v60h-60V60a20 20 0 0 0-40 0v60H60V60z" />
        </svg>
      </div>
      <div className="bb-number">Safety</div>
      <div className="bb-label">Emotional and physical wellbeing is at the heart of everything we do</div>
    </div>

    {/* 4 */}
    <div className="boosting-item">
      <div className="bb-icon">
        {/* rounded L shape */}
        <svg viewBox="0 0 300 160" aria-hidden="true">
          <path d="M80 40a40 40 0 0 1 40 40v40h80a40 40 0 0 1 0 0v40H120a80 80 0 0 1-80-80V80a40 40 0 0 1 40-40z" />
        </svg>
      </div>
      <div className="bb-number">Growth</div>
      <div className="bb-label">Supporting children to reach their potential and build brighter futures</div>
    </div>
  </div>
</div>


{/* Industries Section */}
<div className="industries-section">
  <div className="industries-inner">
    <h2 className="industries-title">Services & Support</h2>

    <div className="industries-grid">
      {/* Column 1 */}
      <div className="industry-card">
        <h3>Residential Care</h3>
        <p>
          We provide safe, stable, and nurturing homes where children can feel secure, valued, and supported in their daily lives
        </p>
      </div>

      {/* Column 2 */}
      <div className="industry-card">
        <h3>Education & Development</h3>
        <p>
          Our team works closely with schools and tutors to ensure every child has access to education, skills, and opportunities that match their potential.
        </p>
      </div>

      {/* Column 3 */}
      <div className="industry-card">
        <h3>Emotional Wellbeing</h3>
        <p>
          Through guidance, mentoring, and therapeutic support, we help children build resilience, confidence, and a sense of self-worth.
        </p>
      </div>
    </div>
  </div>
</div>



{/* Testimonials Section */}
<div className="testimonials-section">
  <div className="testimonials-inner">
    <div className="t-grid">
      {/* Card 1 */}
      <div className="t-card">
        <img
          className="t-avatar"
          src="https://i.pravatar.cc/160?img=5"
          alt="Jenifer Cohen"
        />
        <div className="t-stars" aria-label="5 out of 5 stars">★★★★★</div>
        <p className="t-quote">
          “I’ve seen children flourish here in ways I didn’t think were possible. Their dedication, and genuine love make all the difference”
        </p>
        <div className="t-name">Sarah</div>
      </div>

      {/* Card 2 */}
      <div className="t-card">
        <img
          className="t-avatar"
          src="https://i.pravatar.cc/160?img=32"
          alt="Maria Goncalvales"
        />
        <div className="t-stars" aria-label="5 out of 5 stars">★★★★★</div>
        <p className="t-quote">
          “Careplus Homes gave me more than a roof over my head, they gave me a family. I learned how to believe in myself again”
        </p>
        <div className="t-name">karen, Former Resident</div>
      </div>

      {/* Card 3 */}
      <div className="t-card">
        <img
          className="t-avatar"
          src="https://i.pravatar.cc/160?img=15"
          alt="Michael Soveign"
        />
        <div className="t-stars" aria-label="5 out of 5 stars">★★★★★</div>
        <p className="t-quote">
          “During one of the hardest times of our lives, Careplus Homes supported not just my child but our whole family. We’ll always be grateful.”
        </p>
        <div className="t-name">Parent of a Reunited Child</div>
      </div>
    </div>
  </div>
</div>





{/* Contact Section */}
<div id="contact" className="contact-section">
  <div className="contact-inner">
    {/* Left column */}
    <div className="contact-left">
      <div className="contact-eyebrow">CONTACT</div>
      <h2 className="contact-title">We’re Here to Listen and Support</h2>

      <address className="contact-details">
        <p>Unit 6D Longden Rd, Levenshulme, Manchester M12 5SR</p>
        <p><a href="mailto:info@careplushomes.co.uk">info@careplushomes.co.uk</a></p>
        <p>Tel: <a href="tel:1234567890">123-456-7890</a></p>
      </address>

      
    </div>

    {/* Right column (form) */}
    <form className="contact-form" onSubmit={(e) => e.preventDefault()}>
      <div className="form-row two">
        <div className="field">
          <label htmlFor="firstName">First Name *</label>
          <input id="firstName" type="text" required />
        </div>
        <div className="field">
          <label htmlFor="lastName">Last Name *</label>
          <input id="lastName" type="text" required />
        </div>
      </div>

      <div className="form-row">
        <div className="field">
          <label htmlFor="email">Email *</label>
          <input id="email" type="email" required />
        </div>
      </div>

      <div className="form-row">
        <div className="field">
          <label htmlFor="message">Leave us a message...</label>
          <textarea id="message" rows="4" />
        </div>
      </div>

      <button type="submit" className="contact-submit">Submit</button>
    </form>
  </div>
</div>








      {/* Rest of your About Us content goes here */}
    </div>
  );
};

export default AboutUs;
